import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundColor: 'transparent',
    color: 'var(--tg-theme-text-color, #000)',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 16px',
    backgroundColor: 'rgba(255,245,240,0.85)',
    borderBottom: '1px solid var(--tg-theme-hint-color, #e0e0e0)',
    position: 'sticky',
    top: 0,
    zIndex: 100,
  },
  backBtn: {
    background: 'none',
    border: 'none',
    color: 'var(--tg-theme-link-color, #007aff)',
    fontSize: '24px',
    cursor: 'pointer',
    padding: '4px 8px',
    borderRadius: '6px',
    lineHeight: 1,
  },
  title: {
    fontSize: '17px',
    fontWeight: '600',
    flex: 1,
    textAlign: 'center',
  },
  rightSlot: {
    minWidth: '60px',
    maxWidth: '120px',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  main: {
    flex: 1,
    overflowY: 'auto',
    padding: '0',
  },
};

export default function Layout({ title, children, showBack = false, rightAction, onBack }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <div style={styles.container}>
      {title && (
        <header style={styles.header}>
          <div style={{ minWidth: '60px' }}>
            {showBack && (
              <button style={styles.backBtn} onClick={handleBack}>
                ←
              </button>
            )}
          </div>
          <h1 style={styles.title}>{title}</h1>
          <div style={styles.rightSlot}>{rightAction || null}</div>
        </header>
      )}
      <main style={styles.main}>{children}</main>
    </div>
  );
}
